module.exports = __webpack_public_path__ + "static/img/manxiuleidun.b9e6aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/manxiuleidun.png
// module id = j288
// module chunks = 34